/* eslint-disable i18next/no-literal-string */

import React, {
  ComponentType,
  forwardRef,
  Ref,
} from 'react';
import {
  PatternFormat, PatternFormatProps, InputAttributes,
} from 'react-number-format';

import { Input } from '@ast/magma/components/input';

import CardNumberService from '@app/common/utils/cardNumberService';

type CardInputControlProps = Omit<PatternFormatProps, 'format'> & {
  readonly displayType?: string,
  readonly format?: string;
  readonly prepareValueFormatter?: (value: string) => string;
  readonly label?: string | null;
};

export const DEFAULT_CARD_MAX_LENGTH = 16;
export const DEFAULT_CARD_MIN_LENGTH = 15;

export const defaultPrepareCardValue = (value: string): string => value
  .replace(/\D+/g, '')
  .slice(-DEFAULT_CARD_MAX_LENGTH);

export const cardNumberValidation = (value: string, errorMessage: string) => {
  const preparedValue = defaultPrepareCardValue(value);
  return !CardNumberService.cardLUHNCheckAlgorithm(preparedValue)
  || !CardNumberService.getCardType(preparedValue)
    ? errorMessage
    : true;
};

export const CardNumberInput = forwardRef(
  ({
    format = '#### #### #### ####',
    displayType,
    onChange,
    value,
    prepareValueFormatter,
    ...props
  }:CardInputControlProps, ref: Ref<PatternFormatProps>) => {
    const stringValue = value
      ? value.toString()
      : '';

    const preparedValue = prepareValueFormatter
      ? prepareValueFormatter(stringValue)
      : value;

    return (
      <PatternFormat
        mask=""
        getInputRef={ref}
        inputMode="decimal"
        displayType={displayType}
        customInput={Input as ComponentType<InputAttributes> | undefined}
        format={format}
        value={preparedValue}
        valueIsNumericString
        onValueChange={({ formattedValue }) => {
          if (onChange) {
            onChange(defaultPrepareCardValue(formattedValue) as any);
          }
        }}
        {...props}
      />
    );
  },
);

CardNumberInput.defaultProps = {
  displayType: 'input',
  format: '#### #### #### ####',
  prepareValueFormatter: defaultPrepareCardValue,
  label: '',
};
